import api from '@/api';

export default {
    props: {
        slug: { type: String, required: true },
        campaign: { type: Object, required: true },
    },

    data() {
        return {
            // form
            name: '',
            email: '',

            // ui
            loading: false,
            confirmOpen: false,
            doneOpen: false,

            // language
            lang: 'ko-KR',
        };
    },

    computed: {
        provider() {
            return this.campaign?.provider || 'OB3';
        },
        titleKo() {
            return this.campaign?.titleKo || '';
        },
        titleEn() {
            return this.campaign?.titleEn || '';
        },
        detailLinkUrl() {
            return this.campaign?.detailLinkUrl || '';
        },
        imagePath() {
            return this.campaign?.badgeImagePath || '';
        },

        imageUrl() {
            const base = process.env.VUE_APP_IMAGE_BASE_URL || '';
            return this.imagePath?.startsWith('http')
                ? this.imagePath
                : `${base}${this.imagePath || ''}`;
        },

        titleHtml() {
            const isKor = this.$route?.params?.lang === 'kor';
            return isKor ? (this.titleKo || '') : (this.titleEn || this.titleKo || '');
        },
    },

    watch: {
        '$route.params.lang': 'syncLang',
        '$i18n.locale': 'syncLang',
    },

    created() {
        this.syncLang();
    },

    methods: {
        resolveAcceptLang(v) {
            const s = String(v || '').toLowerCase();
            if (s.startsWith('en') || s === 'eng')
                return 'en-US';
            return 'ko-KR';
        },

        syncLang() {
            const fromRoute = this.$route?.params?.lang;
            const fromI18n = this.$i18n?.locale;
            this.lang = this.resolveAcceptLang(fromRoute || fromI18n || 'ko-KR');
        },

        showConfirm() {
            if (!this.$refs.form?.validate())
                return;
            this.confirmOpen = true;
        },

        async submit() {
            this.loading = true;

            try {
                const body = {
                    name: this.name,
                    eMail: this.email,
                    lang: this.lang,
                    company: this.slug, // ✅ 캠페인 slug = company
                };

                if (this.provider === 'OB3') {
                    await api.post('/OpenBadgesV3', body, {
                        headers: { 'Accept-Language': this.lang },
                    });
                }
                else {
                    await api.post('/OpenBadges', body, {
                        headers: { 'Accept-Language': this.lang },
                    });
                }

                this.confirmOpen = false;
                this.doneOpen = true;

                this.$nextTick(() => {
                    this.name = '';
                    this.email = '';
                    this.$refs.form?.resetValidation?.();
                });
            }
            catch (e) {
                alert(this.$t('trialBadgeCampaign.errors.generic'));
            }
            finally {
                this.loading = false;
            }
        },
    },
};
